module.exports = __webpack_public_path__ + "static/Apparente_edit-635c7c7700dda64e030f8bb13df00d02.gif";